import history from "../utils/history";
import { socketDisconnect } from "./SocketServices";


export const checkSession = () => {
    let token = localStorage.getItem("USER_INFO") && JSON.parse(localStorage.getItem("USER_INFO")).token;
    if(token){
        return true;
    }else{
        socketDisconnect();
        history.push('/');
        return false;
    }
}

